/**
 * WEBAPP-15: modalità ripetizioni scheda (solo esercizi normali in UI v1).
 */

import { pyramidDisplayReps } from './workoutSeriesPlan';

export const WORKOUT_REPS_MODE_OPTIONS = [
    { value: 'fixed', label: 'Fisso' },
    { value: 'range', label: 'Range' },
    { value: 'amrap', label: 'A cedimento' },
];

export function normalizeWorkoutRepsMode(mode) {
    const m = (mode || 'fixed').toLowerCase();
    return WORKOUT_REPS_MODE_OPTIONS.some((o) => o.value === m) ? m : 'fixed';
}

export function isNormalRepsExercise(exercise) {
    if (!exercise) return false;
    const isCardio = exercise.is_cardio === 1 || exercise.is_cardio === true;
    const isIso =
        exercise.is_isometric === 1 ||
        exercise.is_isometric === true ||
        exercise.is_isometric_scheda === 1 ||
        exercise.is_isometric_scheda === true;
    return !isCardio && !isIso;
}

/** Testo compatto per badge/lista (es. «8-12», «A cedimento», «9 → 10 → 11»). */
export function formatWorkoutRepsTarget(exercise) {
    if (!exercise) return '';
    const pyramid = pyramidDisplayReps(exercise);
    if (pyramid) return pyramid;
    const mode = normalizeWorkoutRepsMode(exercise.reps_mode);
    if (mode === 'amrap') return 'A cedimento';
    if (mode === 'range') {
        const min = exercise.ripetizioni_min ?? exercise.ripetizioni;
        const max = exercise.ripetizioni_max ?? exercise.ripetizioni;
        if (min != null && max != null && min !== max) return `${min}-${max}`;
        if (max != null) return String(max);
    }
    return exercise.ripetizioni != null ? String(exercise.ripetizioni) : '';
}

export function getWorkoutRepsModeLabel(mode) {
    const opt = WORKOUT_REPS_MODE_OPTIONS.find((o) => o.value === normalizeWorkoutRepsMode(mode));
    return opt?.label ?? 'Fisso';
}
